import { PageQuery } from '@business/entities/common';
import { CommonService } from '@business/services';
import { Endpoint } from '../endpoint';
import { CompactCalendarEventResponse, ServiceRegionsResponse, SubcontractorApplicationResponse, SubcontractorServiceRegionsResponse, SubcontractorWorkOrderDetailResponse, SubcontractorWorkOrderResponse } from '@business/entities/subcontractor';
import { defineServiceRoleFormData } from '@modules/subContractor/ServiceRoleTab/ServiceRoleForm';
import { ServiceRegionFormData } from '@modules/subContractor/ServiceRegionTab/SubContractorServiceRegionForm';
import { SubContractorSubmitApplicationFormData } from '@modules/subContractor/SubmitApplicationTab';
import { CompactUserResponse, UserId, VeryCompactUserResponse } from '@business/entities/account';
import { NewFormFormData } from '@modules/settings/SettingsPage/Components/SubcontractorTab/Tabs/ProfileFormTab/AddEditAssignFormModal/AddEditAssignFormModal';
import { TimeMaterialId } from '@business/entities/tm';
import { R } from '@core/utils/r';
import { CalendarEventObject } from '@business/entities/calendar_event';
import { ReviewApplicationRequest, ReviewApplicationResponse } from '@business/entities/subcontractor';

export function fetchSubcontractorDetail(id: string) {
  return Endpoint.get<SubcontractorApplicationResponse>(`@gc/subcontractors/subcontractor-detail/${id}`);
}

export function fetchServiceRoles() {
  return Endpoint.get<any>(`@gc/subcontractors/service-role`);
}
export function fetchServiceRegion(id: string) {
  return Endpoint.get<SubcontractorServiceRegionsResponse>(`@gc/subcontractors/service-region/${id}`);
}

export function SubmitApplicationFormData(data: Partial<SubContractorSubmitApplicationFormData>) {
  return Endpoint.post<any>(`@gc/subcontractors/submit-subcontractor-detail`, { data });
}

export function updateMedia(data: any) {
  return mediaRequest(`@gc/subcontractors`, data);
}

function mediaRequest(url: string, data: any) {
  const formData = new FormData();
  formData.append('id', data?.id);
  formData.append('name', data.name);
  formData.append('type', data.type);
  formData.append('url', data.url);
  formData.append('expiryDate', data?.expiryDate);
  const files = data.files || [];
  files.forEach((file: string | Blob) => formData.append('files', file));

  return Endpoint.post<any>(url, {
    formData: formData,
    hasFiles: true,
  });
}

export function upsertServiceRoles(data: Partial<defineServiceRoleFormData>) {
  const formData = CommonService.toFormData(data);
  return Endpoint.post<any>(`@gc/subcontractors/service-role`, { formData, hasFiles: true });
}
export function upsertServiceRegion(data: Partial<ServiceRegionFormData>) {
  const formData = CommonService.toFormData(data);
  return Endpoint.post<ServiceRegionsResponse>(`@gc/subcontractors/service-region`, { formData, hasFiles: true });
}
export function reviewApplicationSubmit(data: ReviewApplicationRequest) {
  return Endpoint.post<ReviewApplicationResponse>(`@gc/subcontractors/review-application`, { data });
}

export function destroyFile(documentId: string) {
  return Endpoint.delete<void>(`@gc/subcontractors/document-destory/${documentId}`);
}


export function fetchSubcontractors() {
  return Endpoint.get<CompactUserResponse[]>(`@gc/subcontractors/contractors`);
}

export function reAssignFormSubcontractor(data: NewFormFormData) {
  return Endpoint.post<void>(`@gc/subcontractor-form/reassign-form`, { data });
}
export function fetchSubcontractorWorkOrders(userId:UserId) {
  return Endpoint.get<SubcontractorWorkOrderResponse[]>(`@gc/subcontractors/work-order/${userId}`);
}
export function fetchSubcontractorWorkOrderDetail(orderId: TimeMaterialId) {
  return Endpoint.get<SubcontractorWorkOrderDetailResponse>(`@gc/subcontractors/work-order-detail/${orderId}`);
}

export function searchSubcontractors(params: PageQuery) {
  return Endpoint.get<VeryCompactUserResponse[]>(`@gc/subcontractors/filter`, {
    params: R.objectCompact(params, { number: true, string: true }),
  });
}
export function fetchProviderEvents(eventObject: CalendarEventObject) {
  return Endpoint.get<CompactCalendarEventResponse[]>(`@gc/subcontractors/provider-calendar-events`, {
    params: R.objectCompact(eventObject, { number: true, string: true }),
  });
}

